import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.scss';
import App from './App.tsx';
import { registerSW } from 'virtual:pwa-register';

import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './auth/config.ts';
import { gwApiAccessTokenOfflineCleanup } from './auth/GatewayApiAccessToken.ts';
/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
gwApiAccessTokenOfflineCleanup();

const msalInstance = new PublicClientApplication(msalConfig);

const initializeMsal = async () => {
  await msalInstance.initialize();

  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }
};

//// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload && (event.payload as any).account) {
    const account = (event.payload as any).account;
    msalInstance.setActiveAccount(account);
  }
});

const updateSW = registerSW({
  onNeedRefresh() {
    updateSW(true);
    window.location.reload();
  },
});

initializeMsal().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App instance={msalInstance} />
    </StrictMode>,
  );
});
